<template>
    <div class = "goods" >
        <div style="width: 47%; float: left">
            <goods-list-item v-for="(item, i) in goods" v-if="i % 2 == 0" :good-item="item"/>
        </div>
        <div style="width: 47%; float: left; margin-left: 2%">
            <goods-list-item v-for="(item, i) in goods" v-if="i % 2 != 0" :good-item="item"/>
        </div>
    </div>
</template>

<script>

    import goodsListItem from "@/components/content/goodsList/goodsListItem";

    export default {
        name: "goodsList",
        components: {
            goodsListItem
        },
        props: {
            goods: {
                type: Array,
                default() {
                    return []
                }
            },
        }
    }
</script>

<style scoped>

    .goods {
        float: left;
        justify-content: space-around;
    }

</style>
